<template>
    <div class="language mx-auto text-center mb-4">
        <a class="small text-center mx-2 cursor-pointer text-muted"
           @click="changeLocale(showLanguage.locale);"
           v-if="locale!==showLanguage.locale">
            <span>{{showLanguage.text}}</span>
        </a>
        <a class="small text-center mx-2 cursor-pointer text-body"
           @click="changeLocale('en');"
           v-if="locale!=='en'">
            ENGLISH
        </a>
    </div>
</template>
<script>
    import {localeChanged} from 'vee-validate';

    export default {
        computed: {
            locale() {
                return this.$store.getters['getLocale']
            },
            showLanguage(){
                const university=process.env.VUE_APP_PROJECT_EXCEPTION??null;
                let language={}
                if(university==='BATUM'){
                    language={
                        text:'ქართული',
                        locale:'ge'
                    }
                }else {
                    language ={
                        text:'TÜRKÇE',
                        locale:'tr'
                    }
                }
                return language
            }
        },
        methods: {
            changeLocale(locale) {
                this.$i18n.locale = locale;
                this.$store.commit('setLocale', locale)
                localeChanged();
            }
        }
    };
</script>
